import { render } from "./advisorListItem.vue?vue&type=template&id=752a1e60"
import script from "./advisorListItem.vue?vue&type=script&lang=js"
export * from "./advisorListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__